import * as Color from 'color';
import { antdStyles } from './antd';

export const generateAntdStyles = (primaryColor: string = '#46b9cb') => {
  const replacedStyles = String(antdStyles)
    .replace(/#1890ff/gi, primaryColor)
    .replace(/#40a9ff/gi, Color(primaryColor).darken(0.15))
    .replace(/#c4def7/gi, Color(primaryColor).alpha(0.25))
    .replace(/#e6f7ff/gi, Color(primaryColor).alpha(0.15))
    .replace(/#7ec1ff/gi, Color(primaryColor).lighten(0.15))
    .replace(/#096dd9/gi, Color(primaryColor).darken(0.2))

    //.ant-input outline
    .replace(/rgba(24,144,255,.2)/gi, Color(primaryColor).alpha(0.15))
    ;

  return replacedStyles;
};

export const generateAntdCustomStyles = (primaryColor: string = '#46b9cb') => {
  const customStyles = `
    /* Cusomt form control outline */
    .app .ant-cascader-picker:focus .ant-cascader-input,
    .app .ant-picker-focused,
    .app .ant-picker-input>input-focused,
    .app .ant-picker-input>input:focus,
    .app .ant-form-item-has-error .ant-transfer-list-search:not([disabled]):focus,
    .app .ant-input-number-focused,
    .app .ant-input-number:focus,
    .app .ant-input-number-focused,
    .app .ant-input-affix-wrapper-focused,
    .app .ant-input-affix-wrapper:focus,
    .app .ant-input-focused,
    .app .ant-input:focus,
    .app .ant-mentions-focused,
    .app .ant-mentions:focus,
    .app .ant-mentions-focused,
    .app .ant-pagination-options-quick-jumper input-focused,
    .app .ant-pagination-options-quick-jumper input:focus,
    .app .ant-select-focused.ant-select-single:not(.ant-select-customize-input) .ant-select-selector,
    .app .ant-select-focused.ant-select-multiple .ant-select-selector,
    .app .ant-switch:focus,
    .app .ant-select-focused.ant-select-multiple .ant-select-selector,
    .app .ant-select-focused.ant-select-single:not(.ant-select-customize-input) .ant-select-selector {
      -webkit-box-shadow: 0 0 0 2px ${Color(primaryColor).alpha(0.2)};
      box-shadow: 0 0 0 2px ${Color(primaryColor).alpha(0.2)};
    }
    .app .ant-slider-handle-dragging.ant-slider-handle-dragging.ant-slider-handle-dragging {
      -webkit-box-shadow: 0 0 0 5px ${Color(primaryColor).alpha(0.2)};
      box-shadow: 0 0 0 5px ${Color(primaryColor).alpha(0.2)};
    }
    .app .ant-menu-dark.ant-menu-horizontal>.ant-menu-item,
    .app .ant-menu-dark.ant-menu-horizontal>.ant-menu-submenu {
      border-color: ${Color(primaryColor).alpha(0.2)};
    }
    .app .ant-radio-input:focus+.ant-radio-inner,
    .app .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled):focus-within,
    .app .ant-radio-group-solid .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled):focus-within {
      -webkit-box-shadow: 0 0 0 3px ${Color(primaryColor).alpha(0.08)};
      box-shadow: 0 0 0 3px ${Color(primaryColor).alpha(0.08)};
    }
    .app .ant-slider-track,
    .app .ant-slider-handle {
      background-color: ${Color(primaryColor).alpha(0.5)};
    }
    .app .ant-slider:hover .ant-slider-track,
    .app .ant-slider:hover .ant-slider-handle:not(.ant-tooltip-open) {
      border-color: ${Color(primaryColor).alpha(0.8)};
    }
    .app .ant-slider-dot-active {
      border-color: ${Color(primaryColor).alpha(0.7)};
    }
    .app .ant-slider-handle-dragging.ant-slider-handle-dragging.ant-slider-handle-dragging {
      border-color: ${Color(primaryColor)};
      -webkit-box-shadow: 0 0 0 5px ${Color(primaryColor).alpha(0.2)};
      box-shadow: 0 0 0 5px ${Color(primaryColor).alpha(0.2)};
    }
    .app .ant-tree .ant-tree-node-content-wrapper.ant-tree-node-selected {
      background-color: ${Color(primaryColor).alpha(0.4)};
    }


    /* custome tab */
    .ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-tab-active {
      background: ${primaryColor} !important;
      color: #fff;
    }
    .ant-tooltip-inner,
    .ant-tooltip-arrow:before {
      background: ${primaryColor} !important;
    }

    /* custome scrollbar */
    .ScrollbarsCustom-Thumb.ScrollbarsCustom-ThumbX,
    .ScrollbarsCustom-Thumb.ScrollbarsCustom-ThumbY {
      background: ${primaryColor} !important;
    }

    /* custome for service stylists */
    .view-services--item-stylists .ant-select-selector {
      background-color: ${Color(primaryColor).alpha(0.15)} !important;
      border-color: ${Color(primaryColor).alpha(0.5)} !important;
    }
  `
  ;

  return customStyles;
};
